import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import ShipmentTrackingLayout from "ui/organizms/Setup/ShipmentTracking";

const ShipmentTracking = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Setup | Shipment Tracking'
    >
        <ShipmentTrackingLayout />
    </Screen>
);

export default memo(ShipmentTracking);
